var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.559,
    height: 9.781,
    viewBox: "0 0 11.559 9.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "card-stack-svgrepo-com",
    d: "M1.889,3.334a.445.445,0,0,1,.445-.445h8.892a.445.445,0,0,1,.445.445V8.669a.445.445,0,0,1-.445.445H2.334a.445.445,0,0,1-.445-.445Zm0,6.593A1.334,1.334,0,0,1,1,8.669V3.334A1.334,1.334,0,0,1,2.334,2h8.892a1.334,1.334,0,0,1,1.334,1.334V8.669a1.334,1.334,0,0,1-.889,1.258v.521a1.334,1.334,0,0,1-1.334,1.334H3.223a1.334,1.334,0,0,1-1.334-1.334ZM10.781,10v.445a.445.445,0,0,1-.445.445H3.223a.445.445,0,0,1-.445-.445V10Z",
    transform: "translate(-1 -2)",
    fill: "#adb7ca",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelStack);
export default __webpack_public_path__ + "static/media/channel-stack.e37ba6c54758ac32073f2d64b2db162c.svg";
export { ForwardRef as ReactComponent };